import {
  GET_FILE_BY_AREA,
  GET_FILE_BY_AREA_SUCCESS,
  GET_FILE_BY_AREA_FAIL,
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAIL,
  CLEAN_VIEW,
  SEND_EMAIL_SUPPLIER,
  SEND_EMAIL_SUPPLIER_SUCCESS,
  SEND_EMAIL_SUPPLIER_FAIL,
  DELETE_FILE_UPLOAD,
  DELETE_FILE_UPLOAD_SUCCESS,
  DELETE_FILE_UPLOAD_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  fileList: [],
  loading: false,
  error: "",
  response: null,
  responseDownloadFile: null,
  responseSend: null,
  responseDeleteUpload: null,
}

const fileUpload = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FILE_BY_AREA:
      return {
        ...state,
        fileList: [],
        loading: true,
        response: null,
      }
    case GET_FILE_BY_AREA_SUCCESS:
      return {
        ...state,
        fileList: action.payload.data,
        loading: false,
      }

    case GET_FILE_BY_AREA_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
      }
    case UPLOAD_FILE:
      return {
        ...state,
        loading: true,
        response: null,
        error: null,
      }
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        response: action.payload.data,
        loading: false,
        error: null,
      }

    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        error: action.payload.data.message,
        loading: false,
        response: null,
      }
    case DOWNLOAD_FILE:
      return {
        ...state,
        responseDownloadFile: null,
        loading: true,
      }
    case DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        error: "",
        responseDownloadFile: action.payload,
        loading: false,
      }
    case DOWNLOAD_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
        responseDownloadFile: null,
        loading: false,
      }
    case CLEAN_VIEW:
      return {
        ...state,
        error: "",
        responseDownloadFile: null,
        responseDeleteUpload: null,
        responseDeleteUpload: null,
        response: null,
      }

    case SEND_EMAIL_SUPPLIER:
      return {
        ...state,
        responseSend: null,
      }
    case SEND_EMAIL_SUPPLIER_SUCCESS:
      return {
        ...state,
        error: "",
        responseSend: action.payload.data,
      }
    case SEND_EMAIL_SUPPLIER_FAIL:
      return {
        ...state,
        error: action.payload,
        responseSend: null,
      }
    case DELETE_FILE_UPLOAD:
      return {
        ...state,
        responseDeleteUpload: null,
        loading: true,
      }
    case DELETE_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        error: "",
        responseDeleteUpload: action.payload.data,
        loading: false,
      }
    case DELETE_FILE_UPLOAD_FAIL:
      return {
        ...state,
        error: action.payload.data,
        responseDeleteUpload: null,
        loading: false,
      }
    default:
      return state
  }
}

export default fileUpload
